import React from 'react'
import { Col, Row } from 'reactstrap'
import { IoIosArrowForward, IoIosArrowDown } from 'react-icons/io'

const PathogenTraditionalDiagnostics = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding5rem1 right-padding5rem1 py-md-5 py-4'>
            <div className=''>
                <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                    Traditional Respiratory Diagnostics
                </div>
                <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>

            </div>

            <div className='py-3'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                Despite the circulation of other, more common viruses and overlapping symptoms, targeted respiratory testing procedures, such as rapid influenza A/B or RSV (Respiratory Syncytial Virus) tests, only detect a tiny percentage of pathogens, leaving doctors to make treatment and management decisions without having all the information.
                </div>
            </div>

            <div className='pt-md-4 pt-3'>
                <Row  className='flex-center'>
                    <Col sm='12' md='12' lg='' className='flex-center pb-md-4 pb-lg-5 pb-3'>
                        <div className='flex-center d-flex justify-content-center me-md-4'>
                        <div className='grid-center'>
                        <center>
                            <img src='pathogen-testing/RPP-Testing-Workflow-icon1.png' alt='' height='auto' width='80px'  />
                            <div className='flex-center fw-500 text-montserrat text-ss-black fs-ss-16 pt-2'>One sample</div>
                            </center>
                            <div className='mt-4  d-flex justify-content-center'>
                                <IoIosArrowDown className='fs-ss-36 text-ss-primary fw-800 display-block1-1'/>
                            </div>
                            </div>
                            <div className='ms-md-4 display-none-991'>
                                <IoIosArrowForward className='fs-ss-36 text-ss-primary fw-800 display-none-991'/>
                            </div>
                        </div>
                            
                            
                        </Col>
                        <Col sm='12' md='12' lg='' className='flex-center pb-md-4 pb-lg-5 pb-3'>
                        <div className='flex-center  d-flex justify-content-center'>
                        <div className='grid-center'>
                        <center>
                            <img src='pathogen-testing/RPP-Testing-Workflow-icon2.png' alt='' height='auto' width='80px'  />
                            <div className='flex-center fw-500 text-montserrat text-ss-black fs-ss-16 lh-1-2 pt-2'><center>Multiple tests<br/> ordered </center></div>
                            </center>
                            <div className='mt-4  d-flex justify-content-center'>
                                <IoIosArrowDown className='fs-ss-36 text-ss-primary fw-800 display-block1-1'/>
                            </div>
                            </div>
                        </div>
                            <div className='ms-md-4'>
                                <IoIosArrowForward className='fs-ss-36 text-ss-primary fw-800 display-none-991'/>
                            </div>
                           
                    </Col>

                    <Col sm='12' md='12' lg='' className='flex-center pb-md-4 pb-lg-5 pb-3'>
                    <div className='flex-center'>
                        <div className='grid-center'>
                        <center>
                            <img src='pathogen-testing/RPP-Testing-Workflow-icon3.png' alt='' height='auto' width='23%'  />
                            <div className='flex-center fw-500 text-montserrat text-ss-black fs-ss-16 lh-1-2 pt-2'><center>Results take hours<br/> to days </center></div>
                            </center>
                            <div className='mt-4  d-flex justify-content-center'>
                                <IoIosArrowDown className='fs-ss-36 text-ss-primary fw-800 display-block1-1'/>
                            </div>
                            </div>
                        </div>
                            <div className='ms-md-4'>
                                <IoIosArrowForward className='fs-ss-36 text-ss-primary fw-800 display-none-991'/>
                            </div>
                           
                    </Col>

                    <Col sm='12' md='12' lg='' className='flex-center pb-md-4 pb-lg-5 pb-3'>
                    <div className='flex-center'>
                        <div className='grid-center'>
                        <center>
                            <img src='pathogen-testing/RPP-Testing-Workflow-icon4.png' alt='' height='auto' width='32%'  />
                            <div className='flex-center fw-500 text-montserrat text-ss-black fs-ss-16 lh-1-2 pt-2'><center>Individual results in<br/> separate reports</center></div>
                            </center>
                            <div className='mt-4  d-flex justify-content-center'>
                                <IoIosArrowDown className='fs-ss-36 text-ss-primary fw-800 display-block1-1'/>
                            </div>
                            </div>
                        </div>
                            <div className='ms-md-4'>
                                <IoIosArrowForward className='fs-ss-36 text-ss-primary fw-800 display-none-991'/>
                            </div>
                           
                    </Col>

                    <Col sm='12' md='12' lg='' className='flex-center pb-md-4 pb-lg-5 pb-3'>
                    <div className='flex-center me-md-3'>
                        <div className='grid-center'>
                        <center>
                            <img src='pathogen-testing/RPP-Testing-Workflow-icon5.png' alt='' height='auto' width='90px'  />
                            <div className='flex-center fw-500 text-montserrat text-ss-black fs-ss-16 lh-1-2 pt-2'><center>Less than optimal<br/> care </center></div>
                            </center>
                            
                            </div>
                        </div>
                          
                    </Col>
                </Row>
            </div>
        </div>
    </div>
  )
}

export default PathogenTraditionalDiagnostics